import { useMemo } from "react";
import { Avatar, Dropdown, Layout, Menu, Modal } from "antd";
import {
  BellOutlined,
  DashboardOutlined,
  DollarOutlined,
  LogoutOutlined,
  MailOutlined,
  MessageOutlined,
  MonitorOutlined,
  SafetyCertificateOutlined,
  ShoppingOutlined,
  TeamOutlined,
  TransactionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { clearToken } from "../api/client";
import avatarTx from "../tx.jpg";

const { Header, Sider, Content } = Layout;

const pathToKey = (pathname: string): string => {
  if (pathname === "/" || pathname === "/overview") return "/overview";
  return pathname;
};

export function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const selected = pathToKey(location.pathname);

  const items = useMemo(
    () => [
      { key: "/overview", icon: <DashboardOutlined />, label: "总览" },
      { key: "/users", icon: <TeamOutlined />, label: "用户" },
      { key: "/orders", icon: <ShoppingOutlined />, label: "订单" },
      { key: "/subscriptions", icon: <TransactionOutlined />, label: "订阅" },
      { key: "/billing-plans", icon: <DollarOutlined />, label: "订阅计划" },
      { key: "/credit-ledger", icon: <UserOutlined />, label: "额度流水" },
      { key: "/feedback", icon: <MessageOutlined />, label: "反馈工单" },
      { key: "/job-runs", icon: <MonitorOutlined />, label: "任务监控" },
      { key: "/alert-dispatches", icon: <MailOutlined />, label: "邮件派发记录" },
      { key: "/alert-prefs", icon: <BellOutlined />, label: "通知偏好" },
      { key: "/email-verification", icon: <SafetyCertificateOutlined />, label: "验证码记录" },
    ],
    [],
  );

  return (
    <Layout className="admin-root">
      <Sider width={256} theme="light" className="admin-sider">
        <div className="admin-sider-head">
          <div className="admin-sider-kicker">MANAGEMENT</div>
          <div className="admin-sider-sub">Backend Console</div>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selected]}
          items={items}
          onClick={({ key }) => navigate(key)}
          className="admin-menu"
        />
      </Sider>
      <Layout>
        <Header className="admin-header admin-header-stitch">
          <div className="admin-header-left">
            <span className="admin-brand">XTool 运维台</span>
          </div>
          <Dropdown
            menu={{
              items: [
                {
                  key: "logout",
                  label: "退出登录",
                  icon: <LogoutOutlined />,
                  danger: true,
                },
              ],
              onClick: ({ key }) => {
                if (key !== "logout") return;
                Modal.confirm({
                  title: "退出登录",
                  content: "确定退出当前账号吗？",
                  okText: "退出",
                  okButtonProps: { danger: true },
                  cancelText: "取消",
                  onOk: () => {
                    clearToken();
                    navigate("/login", { replace: true });
                  },
                });
              },
            }}
            placement="bottomRight"
            trigger={["click"]}
          >
            <button
              type="button"
              className="admin-header-avatar-btn"
              aria-haspopup="menu"
              aria-label="账号菜单"
            >
              <Avatar size={36} src={avatarTx} className="admin-header-avatar" />
            </button>
          </Dropdown>
        </Header>
        <Content className="admin-content admin-content-stitch">
          <div className="admin-content-outlet">
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
